<template lang="pug">
	div.e-toolbar
		div.toolbar
			div.line
				h1(v-show="title").title {{ $translate(title) }}
				div.view-panel(v-if="viewPanelShow()")
					button.view-panel__button.view-table.active(@click="changeView('table')")
					button.view-panel__button.view-chart(v-if="false" @click="changeView('chart')")
					a.view-panel__button.view-map(@click.prevent="redirectToMap")
			div(v-if="showActionsLine").line
				slot(
					name="searchResult"
					v-if="$slots.searchResult"
				)
				div(
					v-else
				).search-result
					span(v-if="showTotal") {{ totalCountMessage }}
				button.actions-panel__button.btn-no-filter.grey(
					:title="$translate('Сбросить сортировку')"
					@click="resetSort()"
					v-if="showResetSortBtn"
				)
				form(@submit.prevent="letSearch" v-if="hideSearch===false").search
					input(type="search" placeholder="" v-model="search")
				div.filter(v-if="useFilterBtn")
					button.filter__button(
						v-if="showFilter"
						@click.stop.prevent="closeFilterPanel"
						:class="{'without-search': hideSearch === true}"
					) {{$translate('Скрыть фильтр')}}
					button.filter__button(
						v-else
						:class="{'without-search': hideSearch === true}"
						@click.stop.prevent="openFilterPanel"
					) {{$translate('Показать фильтр')}}

				div.parameters(v-if="parametersShow()")
					select(v-if="showUnit" @change="changeUnit" v-model="unit").unit
						option(
							v-for="unit in UNIT_OPTIONS"
							:value="unit.id"
						) {{$translate(unit.name)}}
					e-year-selector(year="year" v-if="showYear" @onSelectItem="changeYear")
				div.actions-panel(v-if="actionsPanelShow()")
					template(v-if="visibleColumns")
						button(
							:title="$translate('Отобразить столбцы')"
							@click.stop="filter = !filter"
							v-if="colShow()"
						).actions-panel__button.btn-columns
						div(@click.stop="" v-show="filter").filter-popup
							template(v-if="meta && meta.fields")
								e-perfect-scrollbar
									.item(v-for="(item, fieldName) in meta.fields")
										input.checkbox(
											type="checkbox"
											:id="'checkbox-' + fieldName"
											v-model="visibleColumns"
											:value="fieldName"
											:disabled="(manyVisibleColumns && visibleColumns.indexOf(fieldName) > -1)"
										)
										label(:for="'checkbox-' + fieldName") {{ meta.fields[fieldName].label }}

					button.actions-panel__button.btn-refresh(
						:title="$translate('Актуализация таблицы')"
						@click="reloadTable()"
						v-if="false"
					)

					button.actions-panel__button.btn-upload(
						:title="$translate('Импорт')"
						@click="redirectToImportForm()"
						v-if="importShow()"
					)

					button.actions-panel__button.btn-export(
						:title="$translate('Экспорт')"
						@click="redirectToExport()"
						v-if="exportShow()"
					)

					button.actions-panel__button.btn-delete(
						:title="$translate('Удаление')"
						@click="deleteItems()"
						v-if="deleteShow"
					)

					button.actions-panel__button.btn-add.green(
						:title="$translate('Добавление')"
						@click="add()"
						v-if="addShow()"
					)

					button.actions-panel__button.btn-refresh.grey(
						:title="$translate('Сбросить сортировку')"
						@click="resetSort()"
						v-if="showResetSortBtn"
					)

					router-link(
						:to="{name: 'access.usersGroups.create'}"
						:title="$translate('Добавить группу')"
						tag="button"
						v-if="addUsersGroupsShow()"
						active-class="active"
					).actions-panel__button.green.green--withText {{$translate('Добавить группу')}}

					slot(name="additionalActions")

					// сделать добавление класса .activ текущей вкладке
						// заменить a на button, убрать href
				div(v-if="adminUserPanelShow()").view-panel.admin-user-panel
					router-link(
						:to="{name: 'access.users'}"
						:title="$translate('Пользователи')"
						tag="button"
						active-class="v-active"
						:class="{active: ($route.name === 'access.users')}"
					).view-panel__button.view-users
					router-link(
						:to="{name: 'access.usersGroups'}"
						:title="$translate('Пользователи')"
						tag="button"
						active-class="v-active"
						:class="{active: ($route.name === 'access.usersGroups')}"
					).view-panel__button.view-user-group

		div(
			style="padding: 0;border:none;"
			v-if="!$slots.filter"
		).toolbar-filter
		div(
			v-else
		).toolbar-filter
			slot(name="filter")

</template>

<script>
	import url from '../../utils/url.js'
	import api from '../../api/api'
	import year from '../../utils/year.js'
	import { ROUTE_NAME_LAYER_MAP } from '../../config/map.js'
	import { PERMS } from '../../config/permissions'
	import permissionMixin from '../../mixins/permission-mixin.js'
	import { UNIT_OPTIONS, WALL } from '../../config/config'
	import saveFile from '../../utils/saveFile'

	const DEFAULT_UNIT = UNIT_OPTIONS[0].id
	const DEFAULT_YEAR = year.getCurrentYear()

	export default {
		mixins: [permissionMixin],
		name: 'e-toolbar',
		data() {
			return {
				search: '',
				filter: false,
				find: false,
				year: DEFAULT_YEAR,
				unit: DEFAULT_UNIT,
				isActive: true,
				api: api
			}
		},
		props: {
			showResetSortBtn: {
				type: Boolean,
				default: false
			},
			showYear: {
				type: Boolean,
				default: false
			},
			showUnit: {
				type: Boolean,
				default: false
			},
			showActionsPanel: {
				type: Boolean,
				default: true
			},
			showTotal: {
				type: Boolean,
				default: false
			},
			showCol: {
				type: Boolean,
				default: true
			},
			showViewPanel: {
				type: Boolean,
				default: true
			},
			showExport: {
				type: Boolean,
				default: false
			},
			endpointExport: {
				type: String,
				default: ''
			},
			showAdminUserPanel: {
				type: Boolean,
				default: false
			},
			showFilter: {
				type: Boolean,
				default: true
			},
			showChart: {
				type: Boolean,
				default: true
			},
			showActual: {
				type: Boolean,
				default: false
			},
			hideRemoveButton: {
				type: Boolean,
				default: false
			},
			hideAddButton: {
				type: Boolean,
				default: false
			},
			hideSearch: {
				type: Boolean,
				default: false
			},
			hideAddUsersGroupsButton: {
				type: Boolean,
				default: true
			},
			autoAdd: {
				type: Boolean,
				default: true
			},
			autoSearch: {
				type: Boolean,
				default: true
			},
			autoRedirectToMap: {
				type: Boolean,
				default: true
			},
			toolbarTitle: {
				type: String,
				default: ''
			},
			tableId: {
				type: String,
				default: function () {
					return this.$route.name
				}
			},
			hideImportBtn: {
				type: Boolean,
				default: false
			},
			routeMapName: {
				type: String,
				default: 'geo.objects'
			},
			showActionsLine: {
				type: Boolean,
				default: true
			},
			useFilterBtn: {
				type: Boolean,
				default: false
			},
			yearRange: {
				type: Array,
				default: () => [-3, 0]
			}
		},
		watch: {
			'$route': 'setFiltersFromUrl'
		},
		computed: {
			UNIT_OPTIONS() {
				return UNIT_OPTIONS
			},
			manyVisibleColumns() {
				return (this.visibleColumns || []).length < 2
			},
			visibleColumns: {
				get() {
					return this.$store.getters.tableState(this.tableId, 'visibleColumns')
				},
				set(value) {
					this.$store.commit('tableState', {
						id: this.tableId,
						param: 'visibleColumns',
						data: value
					})
				}
			},
			yearsOptions() {
				const [start, end] = this.yearRange
				return year.getYears(start, end)
			},
			title() {
				if (this.toolbarTitle) {
					return this.toolbarTitle
				} else if (this.$route.query.prevRoute) {
					if (this.$route.matched[1]) {
						return this.$route.matched[1].meta.title
					}
					return ''
				} else {
					return this.$route.meta.title
				}
			},
			meta() {
				return this.$store.getters.tableState(this.tableId, 'meta')
			},
			getRouteLayerMap() {
				return ROUTE_NAME_LAYER_MAP
			},
			deleteShow() {
				return this.userCanDelete && !this.hideRemoveButton
			},
			totalCountMessage() {
				let msg = ''
				if (this.meta) {
					msg += this.$translate('Всего объектов: ')
					if (typeof this.meta === 'object' && this.meta.hasOwnProperty('totalCount')) {
						msg += this.meta.totalCount
					} else {
						msg += '-'
					}
				}
				return msg
			}
		},
		created() {
			this.setFiltersFromUrl()
			window.addEventListener('click', this.outerClick)
		},
		destroyed() {
			window.removeEventListener('click', this.outerClick)
		},
		methods: {
			outerClick() {
				this.filter = false
			},
			setFiltersFromUrl() {
				let route = url.getRoute(this.$route)
				if (route.query.q) {
					this.search = route.query.q
				} else {
					this.search = ''
				}
				if (route.query.year) {
					this.year = route.query.year
				} else {
					this.year = DEFAULT_YEAR
				}
				if (route.query.unit) {
					this.unit = route.query.unit
				} else {
					this.unit = DEFAULT_UNIT
				}
			},
			redirectToMap() {
				this.$emit('redirectToMap')
				if (this.autoRedirectToMap === true) {
					let current = url.getRoute(this.$route)
					if (this.getRouteLayerMap[current.name]) {
						this.$router.push({ name: this.routeMapName, query: { layers: this.getRouteLayerMap[current.name] } })
					} else {
						this.$router.push({ name: this.routeMapName, query: {} })
					}
				}
			},
			reloadTable() {
				this.$emit('reloadTable')
			},
			redirectToExport() {
				if (this.$props.endpointExport) {
					this.$bar.start()
					this.api.get(this.$store.getters.authToken, this.$props.endpointExport, {responseType: 'arraybuffer'}, this.$store)
					.then(r => {
						let fileName = `export-excel.xlsx`
						let blob = new Blob([r.request.response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
						const fileURL = window.URL.createObjectURL(blob);
						const fileLink = document.createElement('a');
						fileLink.href = fileURL;
						fileLink.setAttribute('download', fileName)
						document.body.appendChild(fileLink)
						fileLink.click()
					}).catch(e => {
						this.$message({ message: e.message, type: 'error', duration: WALL.ERROR_TIMEOUT })
					}).finally(() => {
						this.$bar.finish()
					})
				}
			},
			deleteItems() {
				this.$emit('deleteItems')
			},
			add() {
				this.$emit('add')
				if (this.autoAdd === true) {
					let route = url.getRoute(this.$route)
					let json = url.getRoute(this.$route, true)
					this.$router.push({ name: route.name + '.create', query: { prevRoute: json } })
				}
			},
			changeView(view) {
				this.$emit('setView', view)
			},
			// TODO: move to computed all
			parametersShow() {
				if (this.showUnit || this.showYear) {
					return true
				}
				return false
			},
			actionsPanelShow() {
				return this.showActionsPanel
			},
			colShow() {
				return this.showCol
			},
			viewPanelShow() {
				return this.showViewPanel
			},
			adminUserPanelShow() {
				return this.showAdminUserPanel
			},
			importShow() {
				return this.userCanCreate && !this.hideImportBtn && this.userHavePermission(PERMS.VIEW, {
					name: 'import'
				})
			},
			exportShow() {
				return this.showExport
			},
			addShow() {
				return this.userCanCreate && !this.hideAddButton
			},
			addUsersGroupsShow() {
				if (this.hideAddUsersGroupsButton === true || !this.userCanCreate) {
					return false
				}
				return true
			},
			actualShow() {
				return this.showActual
			},
			changeUnit() {
				this.$emit('changeUnit', this.unit)
				if (this.autoSearch) {
					let route = url.getRoute(this.$route)
					route.query.unit = this.unit
					if (!route.query.unit) {
						delete route.query.unit
					}
					this.$router.push(route)
				}
			},
			changeYear() {
				this.$emit('changeYear', this.year)
				if (this.autoSearch) {
					let route = url.getRoute(this.$route)
					route.query.year = this.year
					if (!route.query.year) {
						delete route.query.year
					}
					this.$router.push(route)
				}
			},
			letSearch() {
				this.$emit('letSearch', this.search)
				if (this.autoSearch) {
					let route = url.getRoute(this.$route)
					route.query.q = this.search
					if (!route.query.q) {
						delete route.query.q
					}
					this.$router.push(route)
				}
			},
			redirectToImportForm() {
				this.$router.push({
					name: 'import.importExcel',
					query: {
						fromName: this.$route.name,
						prevRoute: url.getRoute(this.$route, true)
					}
				})
			},
			resetSort() {
				let route = url.getRoute(this.$route)
				if (!route.query.sort) {
					return
				}
				delete route.query.sort
				this.$router.push(route)
			},
			openFilterPanel() {
				this.$emit('openFilterPanel')
			},
			closeFilterPanel() {
				this.$emit('closeFilterPanel')
			}
		}
	}
</script>
